import React from "react";

interface StatusChipProps {
  background: string;
  text: string;
  textColor: string;
  icon?: React.ReactNode;
}

const ProjectStatusChip: React.FC<StatusChipProps> = ({
  background,
  text,
  textColor,
  icon,
}) => (
  <div
    className="relative inline-flex items-center gap-2 rounded-full px-3 py-1 text-[14px] font-[450] whitespace-nowrap"
    style={{ backgroundColor: background, color: textColor }}
  >
    {icon && (
      <span className="w-4 h-4 flex items-center justify-center" style={{ color: textColor }}>
        {icon}
      </span>
    )}
    <span className="!font-[500] CircularStd">{text}</span>
  </div>
);

export default ProjectStatusChip;
